import { render } from "./CourseActivity.vue?vue&type=template&id=2c7bef84&ts=true"
import script from "./CourseActivity.vue?vue&type=script&lang=ts"
export * from "./CourseActivity.vue?vue&type=script&lang=ts"

import "./CourseActivity.vue?vue&type=style&index=0&id=2c7bef84&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__